export const SupportSheetCheckListConstant = {
    "Check Hanover": "Pre-1.",
    "Send greating to owners": "Pre-2.",
    "Send greating to chtrs": "Pre-3.",
    "Create folder on onedrive": "Pre-4.",
    "Ask pre-stowage plan": "Pre-5.",
    "Confirm prestowage plan": "Pre-6.",
    "Loi format": "Pre-7.",
    "Agent details at loadport": "Pre-8.",
    "Agent details at disport": "Pre-9.",
    "Send draft FN to owner": "Pre-10.",
    "Both sides signed FN": "Pre-11.",
    //TCT, TC
    "Vessels contact detail": "Pre-12.",
    "Voyage instruction": "Pre-13.",
    "Onhire bunker survey": "Pre-14.",
    "Offhire bunker survey": "Pre-15.",
    "We dont follow this shipment": "Pre-16.",

    "Check if loadport agent has been appointed": "On-1.",
    "Obtain prestowage plan": "On-2.",
    "When sub vsl arrives loadport, obtain NOR and send to Chtrs": "On-3.",
    "During loading, obtain draft BL and get Chtrs Owners confirmation.": "On-4.",
    "Check if Disport agent has been appointed?": "On-5.",
    "When sub vsl completes loading and depart from loadport, obtain Freight invoice+loading docs.": "On-6.",
    "Send freight invoice to Chtrs (please remember to verify bank account)": "On-7.",
    "Check cargo will be discharged/released at disport against?": "On-8.",
    "Obtained that doc and send to Owners.": "On-9.",
    "Obtain bank slip from Charterers and send to Owners.": "On-10.",
    "Owners received payment?": "On-11.",
    "When sub vsl arrives disport, obtain NOR and send to Chtrs": "On-12.",
    "After completion of discharging, obtain cargo docs and send to Chtrs": "On-13.",
    //TCT, TC
    "Obtain Vessels contact details + LOI format from Owners": "On-14.",
    "Obtain voyage instruction + onhire bunker survey from Charterers.": "On-15.",
    "After Delivery, obtain Delivery cert/info + 1st hire invoice": "On-16.",
    "Send invoice to Charterer and follow up till Owners receive payment": "On-17.",
    "During shipment, obtain next invoices when hire is due and follow up till Owners receive payment.": "On-18.",
    "Check offhire bunker survey": "On-19.",
    "Check with Chtrs for tentative itinerary + est. Redelivery date.": "On-20.",
    "Update vessel\'s itinerary + Redelivery notice to Owners": "On-21.",

    "Draft brokerage invoice and send to Brokers for checking.": "Post-1.",
    "After get confirmation, submit to Ms. Nina/Mr. Minh for sign/Ms. Ngan for stamp.": "Post-2.",
    "Send signed/stamped invoice to clients (please remember to verify bank account)": "Post-3.",
    "Receive payment?": "Post-4.",
    "Send thank you email to Client.": "Post-5.",
    "Save necessary documents": "Post-6.",
    "Analysis and report": "Post-7.",
    "Confirm close file": "Post-8.",
    //VOY
    "Select here if LTC isnt applicable": "Post-9.",
    "If laytime settlement is applicable for this shipment, please ask Owners/Chtrs to send LTC": "Post-10.",
    "Follow up till both sides have a mutual agreement.": "Post-11.",
    "After both sides confirm laytime calculation, obtain FFI/Despatch invoice from ": "Post-12.",
    "Send to Charterers/Owners.": "Post-13.",
    "Send bank slip to Owners/Charterers": "Post-14.",
    "Owners/Chtrs received payment?": "Post-15.",
    //TCT
    "After the vessel is redelivered to Owners, ask Owners for FHS ": "Post-16.",
    "Follow till both  sides have a mutual agreement.": "Post-17.",
    "After both sides confirm FHS, ask Chtrs/Owners to issue final hire invoice.": "Post-18.",
    "Send final hire invoice to Charterers/Owners.": "Post-19.",
    "Obtain bank slip from Chtrs/Owners and send to Owners/Charterers.": "Post-20.",

    containValue: (value: string) => {
        return Object.values(SupportSheetCheckListConstant).indexOf(value) > -1;
    }
}